var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 79,
    viewBox: "0 0 90 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_?\xEB\x8D\x89\xEC\x94\xA0??1",
    clipPath: "url(#clip0_152_824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.90732 46.7108H9.20853C10.1511 46.7108 10.9101 47.4756 10.9101 48.4253V67.671C10.9101 68.6207 10.1511 69.3855 9.20853 69.3855H7.90732C3.54495 69.3855 0 65.8137 0 61.4183V54.678C0 50.2826 3.54495 46.7108 7.90732 46.7108Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M82.0843 69.3855H80.7831C79.8406 69.3855 79.0816 68.6207 79.0816 67.671V48.4253C79.0816 47.4756 79.8406 46.7108 80.7831 46.7108H82.0843C86.4467 46.7108 89.9917 50.2826 89.9917 54.6781V61.4183C89.9917 65.8137 86.4467 69.3855 82.0843 69.3855Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.1103 0H59.5301C71.0825 0 80.4578 9.44638 80.4578 21.0863V22.6747H8.18259V21.0863C8.18259 9.44638 17.5579 0 29.1103 0Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.81464 37.0964H80.4495V62.5025C80.4495 71.6043 73.1094 79.0001 64.076 79.0001H23.1881C14.1548 79.0001 6.81464 71.6043 6.81464 62.5025V37.0964Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.6089 48.7027C37.7375 48.7027 38.6525 47.7808 38.6525 46.6436C38.6525 45.5065 37.7375 44.5846 36.6089 44.5846C35.4803 44.5846 34.5653 45.5065 34.5653 46.6436C34.5653 47.7808 35.4803 48.7027 36.6089 48.7027Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M50.9221 48.7027C52.0508 48.7027 52.9657 47.7808 52.9657 46.6436C52.9657 45.5065 52.0508 44.5846 50.9221 44.5846C49.7935 44.5846 48.8786 45.5065 48.8786 46.6436C48.8786 47.7808 49.7935 48.7027 50.9221 48.7027Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M43.8906 54.5856C41.5218 54.5856 39.8452 51.9299 39.7785 51.8206L40.9379 51.0895C41.3049 51.6778 42.5561 53.2074 43.899 53.2074C44.8165 53.2074 45.7257 52.493 46.6015 51.0895L47.7609 51.8206C46.6265 53.6528 45.3253 54.5856 43.899 54.5856H43.8906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M64.5598 52.1484C65.1264 52.1484 65.5857 51.6856 65.5857 51.1147C65.5857 50.5437 65.1264 50.0809 64.5598 50.0809C63.9932 50.0809 63.5338 50.5437 63.5338 51.1147C63.5338 51.6856 63.9932 52.1484 64.5598 52.1484Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M61.4903 56.2665C62.0569 56.2665 62.5162 55.8037 62.5162 55.2328C62.5162 54.6619 62.0569 54.1991 61.4903 54.1991C60.9237 54.1991 60.4643 54.6619 60.4643 55.2328C60.4643 55.8037 60.9237 56.2665 61.4903 56.2665Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M67.6293 56.2665C68.1959 56.2665 68.6552 55.8037 68.6552 55.2328C68.6552 54.6619 68.1959 54.1991 67.6293 54.1991C67.0627 54.1991 66.6033 54.6619 66.6033 55.2328C66.6033 55.8037 67.0627 56.2665 67.6293 56.2665Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M22.9713 52.1484C23.5379 52.1484 23.9972 51.6856 23.9972 51.1147C23.9972 50.5437 23.5379 50.0809 22.9713 50.0809C22.4046 50.0809 21.9453 50.5437 21.9453 51.1147C21.9453 51.6856 22.4046 52.1484 22.9713 52.1484Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M19.9018 56.2665C20.4684 56.2665 20.9277 55.8037 20.9277 55.2328C20.9277 54.6619 20.4684 54.1991 19.9018 54.1991C19.3352 54.1991 18.8758 54.6619 18.8758 55.2328C18.8758 55.8037 19.3352 56.2665 19.9018 56.2665Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M26.0408 56.2665C26.6074 56.2665 27.0667 55.8037 27.0667 55.2328C27.0667 54.6619 26.6074 54.1991 26.0408 54.1991C25.4742 54.1991 25.0148 54.6619 25.0148 55.2328C25.0148 55.8037 25.4742 56.2665 26.0408 56.2665Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M84.8536 20.6072H5.14643C2.30414 20.6072 0 22.9288 0 25.7926V34.6591C0 37.5229 2.30414 39.8445 5.14643 39.8445H84.8536C87.6959 39.8445 90 37.5229 90 34.6591V25.7926C90 22.9288 87.6959 20.6072 84.8536 20.6072Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M3.4115 58.0482H6.81465",
    stroke: "#878787",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M80.4495 57.359H83.861",
    stroke: "#878787",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 79,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImage3);
export default __webpack_public_path__ + "static/media/cardImage3.bb7f58c1c4b4e3c7d97636a901797d80.svg";
export { ForwardRef as ReactComponent };